import { client } from "./client";

export const uploadFile = ({ userId, formData }) =>
  client.post(`/api/user/${userId}/uploadFile`, formData);
